function addLinkToBss(form) {
  if (form) {
    if (!form.querySelector(".redirect_form_bss")) {
      form.insertAdjacentHTML(
        "beforeend",
        `
  <a href="/pages/formulaire-dinscription-pro" class="btn btn--primary redirect_form_bss" style="
    width: 100%;
    margin-top: 10px;
"> Créer un compte Pro
  </a>`
      );
    }
  }
}

setTimeout(() => {
  const forms = document.querySelectorAll(
    "#account-login, #header-account-login"
  );

  if (forms.length) {
    forms.forEach((form) => {
      addLinkToBss(form);
    });
  }

  const buttonShowMenu = document.querySelectorAll(
    ".header__menu-icon[data-aria-label-closed]"
  );
  if (buttonShowMenu.length) {
    buttonShowMenu.forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(() => {
          const form = document.querySelector("#mobile-menu-account-login");
          addLinkToBss(form);
        }, 300);
      });
    });
  }
}, 300);
